import { SupportActions } from '../constants/support';

export const selectReport = state => state.common[SupportActions.Report];